import { createResourceSlice, resourceInitialState } from 'store/ResourceSlice';
import { SeasonState } from 'typings/state';

export const initialState: SeasonState = resourceInitialState();

const slice = createResourceSlice({
    name: 'season',
    initialState,
});

export const season = slice.reducer;
export const actions: typeof slice.actions = slice.actions;
